// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module--row--2Qdc9","row__row--centered":"styles-module--row__row--centered--1nHIa","row__col":"styles-module--row__col--DBbjC"};